import CloseIcon from "@mui/icons-material/Close";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IconButton } from "@mui/material";

import { useState } from "react";
import ApiMethods from "../../../../ApiManager/ApiMethods";
import { useAlert } from "../../../context/AlertContext";
import useLockBodyScroll from "../../../hooks/useLockBodyScroll";
import "./deletePopup.css";

const DeletePopUp = ({
  closePopUp,
  activeClientInformation,
  setActiveClientInformation,
  setClientActiveId,
  deleteAppointment,
  onConfirm,
  message = "Da li ste sigurni da želite da obrišete ovog korisnika?",
  // Optional reason/status picker — e.g. [{ value: "canceled", label:
  // "Otkazano" }, { value: "noshow", label: "Nije se pojavio/la" }]. When
  // provided, the selected option's `value` is passed as the first argument
  // to `onConfirm`. Omitted entirely by every other caller of this shared
  // popup (delete member, remove photo, etc.), so their behavior/markup is
  // completely unchanged.
  options,
}) => {
  console.log("ovo je onconfirm", onConfirm);
  const { showAlert, closeAlert } = useAlert();
  useLockBodyScroll();
  const [selectedOption, setSelectedOption] = useState(
    () => options?.[0]?.value ?? null
  );

  const deleteUser = async () => {
    console.log(activeClientInformation.id);
    const token = localStorage.getItem("googleAccessToken");
    const data = {
      googleToken: token,
    };

    console.log("ovo je googleToken", token);
    const response = await ApiMethods.post(
      `auth/delete_client/${activeClientInformation.id}`,
      data
    );
    if (response.message) {
      showAlert("Uspesno brisanje!", "success");
    }

    closePopUp();
    setClientActiveId();
    setActiveClientInformation(undefined);
  };

  return (
    <div className="hf-del-overlay">
      <div className="hf-del-card">
        <IconButton
          className="hf-del-close"
          aria-label="Zatvori"
          onClick={closePopUp}
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        <div className="hf-del-icon">
          <DeleteOutlineIcon sx={{ fontSize: 26 }} />
        </div>

        <p className="hf-del-message">{message}</p>

        {options && options.length > 0 && (
          <div className="hf-del-options">
            {options.map((opt) => (
              <button
                key={opt.value}
                type="button"
                className={`hf-del-option${
                  selectedOption === opt.value ? " selected" : ""
                }`}
                onClick={() => setSelectedOption(opt.value)}
              >
                {opt.label}
              </button>
            ))}
          </div>
        )}

        <div className="hf-del-actions">
          <button
            type="button"
            onClick={async () => {
              if (onConfirm) {
                await onConfirm(options ? selectedOption : undefined);
              } else {
                deleteUser();
              }
            }}
            className="hf-del-confirm-btn"
          >
            Potvrdi
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePopUp;
